import { InputHidden } from "../../../components/Core";
import React from "react";
import { useToursContext } from "./context";

export default function HiddenFields({ omit }) {
    const {
        page: { request }
    } = useToursContext();
    return (
        <div>
            {
                Object.keys(_.omit(request, omit)).map((request_item, key) => {
                    if (!_.isEmpty(request[request_item])) {
                        if (Array.isArray(request[request_item])) {
                            {
                                return (

                                    request[request_item].map((_param, childKey) => {

                                        return (
                                            <InputHidden key={childKey} name={request_item + '[]'} defaultValue={_param} />
                                        )
                                    })
                                )
                            }
                        }
                        else {
                            return (
                                <InputHidden key={key} name={request_item} defaultValue={request[request_item]} />
                            )
                        }
                    }
                })
            }
        </div>
    )
}


// WEBPACK FOOTER //
// ./resources/js/react/components/ToursIndex/HiddenFields.jsx